/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import Ajax from '@fusioncharts/core/src/ajax';
import { getDepsByType } from '@fusioncharts/core/src/dependency-manager';
import { xssEncode } from '@fusioncharts/core/src/lib';

let UNDEF,
  transcoders = getDepsByType('transcoder');

/**
 * Call back function when submit button is pressed.
 */
function submitData () {
  var chart = this,
    // iapi = chart.apiInstance,
    ajaxObj = new Ajax(),
    chartConf = chart.config,
    json = transcoders.json(),
    csv = (transcoders.csv && transcoders.csv()) || 'csv',
    xml = transcoders.xml(),
    url = chartConf.formAction,
    chartInstance = chart.getFromEnv('chartInstance'),
    requestType,
    data,
    paramObj,
    tempSpan,
    formEle;

  if (chartConf.formDataFormat === json.format) {
    requestType = json.format;
    if (chart.getJSONData) {
      data = JSON.stringify(chart.getJSONData());
    }
    if (chart.getCollatedData) {
      data = JSON.stringify(chart.getCollatedData());
    }
  } else if (chartConf.formDataFormat && chartConf.formDataFormat === csv.format) {
    requestType = csv.format;
    data = chart.getCSVString && chart.getCSVString();
    if (data === UNDEF || data === '') {
      if (chart.getJSONData) {
        data = csv.fromJSON(chart.getJSONData()).data;
      }
      if (chart.getCollatedData) {
        data = csv.fromJSON(chart.getCollatedData()).data;
      }
    }
  } else {
    requestType = xml.format;
    if (chart.getCollatedData) {
      data = xml.fromJSON(chart.getCollatedData()).data;
    }
    if (chart.getJSONData) {
      data = xml.fromJSON(chart.getJSONData()).data;
    }
  }

  // cancel data submit function added in event options
  /**
    * For interative charts like `Select Scatter`, `DragNode`, `Dragable Column2D ` and etc., data
    * points value can be selected for `Scatter Chart` and values can be changed for dragable charts by
    * clicking and dragging the data points whose data point values can be sent to an URL by ajax POST.
    * This is the first event raised when `Submit` button is clicked where the current chart data is
    * about to be sent to the set URL.
    *
    * @event FusionCharts#beforeDataSubmit
    * @group chart-powercharts
    *
    * @param {string} data - Contains the XML string with complete chart data at it's current state.
    *
    */
  chart.fireChartInstanceEvent('beforeDataSubmit', {
    data: data
  }, UNDEF, function () {
    // After the collation is done, we have to submit the data using
    // ajax or form submit method.
    if (!chartConf.submitFormAsAjax) {
      // Create a hidden form with data inside it.
      tempSpan = window.document.createElement('span');
      tempSpan.innerHTML = '<form style="display:none" action="' +
        url + '" method="' + chartConf.formMethod + '" target="' + chartConf.formTarget +
        '"> <input type="hidden" name="strXML" value="' +
        xssEncode(data) + '"><input type="hidden" name="dataFormat" value="' +
        requestType.toUpperCase() + '" /></form>';

      formEle = tempSpan.removeChild(tempSpan.firstChild);

      // Append the form to body and then submit it.
      window.document.body.appendChild(formEle);
      formEle.submit && formEle.submit();
      // cleanup
      formEle.parentNode.removeChild(formEle);
      tempSpan = formEle = null;
    } else {
      // eslint-disable-next-line
      ajaxObj.onError = function (response, wrapper, ajaxData, url) {
      /**
        * For interative charts like `Select Scatter`, `DragNode`, `Dragable Column2D ` and etc.,
        * data points value can be selected for `Scatter Chart` and values can be changed for
        * dragable charts by clicking and dragging the data points whose data point values can be
        * sent to an URL by ajax POST. This event is raised if there is an ajax error in sending
        * the chart XML data.
        *
        * @event FusionCharts#dataSubmitError
        * @group chart-powercharts
        *
        * @param {string} data - Contains the XML string with complete chart data.
        * @param {number} httpStatus - Tells the status code of the ajax POST request
        * @param {string} statusText - Contains the ajax error message.
        * @param {string} url - URL to which the data is sent as ajax POST request.
        * @param {object} xhrObject - XMLHttpRequest object which takes care of sending the XML
        * chart data. In case of error, this object won't be defined.
        */
        chart.fireChartInstanceEvent('dataSubmitError', {
          xhrObject: wrapper.xmlhttp,
          url: url,
          statusText: response,
          httpStatus: (wrapper.xmlhttp && wrapper.xmlhttp.status)
            ? wrapper.xmlhttp.status : -1,
          data: data
        }, [chartInstance.id, response, wrapper.xmlhttp && wrapper.xmlhttp.status]);
      };
      // eslint-disable-next-line
      ajaxObj.onSuccess = function (response, wrapper, ajaxData, url) {
      /**
        * For interative charts like `Select Scatter`, `DragNode`, `Dragable Column2D ` and etc.,
        * data points value can be selected for `Scatter Chart` and values can be changed for
        * dragable charts by clicking and dragging the data points whose data point values can be
        * sent to an URL by ajax POST. This event is raised when the ajax POST request is
        * successfully completed.
        *
        * @event FusionCharts#dataSubmitted
        * @group chart-powercharts
        *
        * @param {string} data - Contains the XML string with complete chart data.
        * @param {string} reponse - Contains the reponse returned by the web server to which the
        * HTTP POST request was submitted.
        * @param {string} url - URL to which the data is sent as HTTP POST request.
        * @param {object} xhrObject - XMLHttpRequest object which takes care of sending the XML
        * chart data
        */
        chart.fireChartInstanceEvent('dataSubmitted', {
          xhrObject: ajaxObj,
          response: response,
          url: url,
          data: data
        }, [chartInstance.id, response]);
      };

      paramObj = {};
      paramObj['str' + requestType.toUpperCase()] = data;

      if (ajaxObj.open) {
        ajaxObj.abort();
      }
      ajaxObj.post(url, paramObj);
    }
  }, function () {
    /**
      * For interative charts like `Select Scatter`, `DragNode`, `Dragable Column2D ` and etc.,
      * data points value can be selected for `Scatter Chart` and values can be changed for
      * dragable charts by clicking and dragging the data points whose data point values can be
      * sent to an URL by ajax POST. This event is raised when `preventDefault()` method is called
      * from the `eventObject` of FusionCharts#beforeDataSubmit event.
      *
      * @event FusionCharts#dataSubmitCancelled
      * @group chart-powercharts
      *
      * @param {string} data - Contains the XML string with complete chart data.
      * @param {number} httpStatus - Tells the status code of the ajax POST request
      * @param {string} statusText - Contains the ajax error message.
      * @param {string} url - URL to which the data is sent as ajax POST request.
      * @param {object} xhrObject - XMLHttpRequest object which takes care of sending the XML
      * chart data. In case of error, this object won't be defined.
      * @example
      * FusionCharts.addEventListener('beforeDataSubmit', function(eventObject, parameterObject) {
      *  eventObject.preventDefault();
      * }
      */
    chart.fireChartInstanceEvent('dataSubmitCancelled', {
      data: data
    });
  });
}

export { submitData };
